import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AngleValidator, AzimuthRangeValidator, forbiddenDocValidator } from 'src/app/data-validation/data-validators.service';
import { ScreeningAngle } from 'src/app/models/screening-angle';
import { NavaidsService } from 'src/app/services/navaids.service';

@Component({
  selector: 'app-add-navaid-angles',
  templateUrl: './add-navaid-angles.component.html',
  styleUrls: ['./add-navaid-angles.component.scss'],
  standalone: false
})
export class AddNavaidAnglesComponent implements OnInit {

  angle : ScreeningAngle;

  verticalAngleValid : boolean = true;
  minAlgleValid : boolean = true;
  maxAngleValid : boolean = true;

  isBiggerThenValid : boolean = false;

  constructor(public navaidService : NavaidsService) {
    this.angle = new ScreeningAngle();
  }

  ngOnInit(): void {
    /*this.angleForm = new FormGroup({
      verticalangle: new FormControl(this.angle.verticalangle,[Validators.required,
        forbiddenDocValidator(90,-90)]),
      minangle : new FormControl(this.angle.minangle,[Validators.required, Validators.min(0), Validators.max(360)]),
      maxangle : new FormControl(this.angle.maxangle,[Validators.required, Validators.min(0), Validators.max(360)])
    },
    {validators: [AngleValidator]});*/
  }

  checkFormValid() {
    let verticalAngleValue : boolean = this.angle.verticalangle != null;
    let minAngleValue : boolean = this.angle.minangle != null;
    let maxAngleValue : boolean = this.angle.maxangle != null;
    return this.verticalAngleValid && this.minAlgleValid && this.maxAngleValid
    && verticalAngleValue && minAngleValue && maxAngleValue && !this.isBiggerThenValid;
  }

  isBiggerThen(value1 : any, value2: any){
    if(value1 != undefined && value2 != undefined){
      if (value1 > value2){
        this.isBiggerThenValid = true;
      }else {
        this.isBiggerThenValid = false;
      }
    }else {
      this.isBiggerThenValid = false;
    }
  }

  isValueValid(type : string, value : any) : void {
    if (value != null) {
      switch(type) {
        case "verticalangle":
          if (!(Number.parseFloat(value) >= -90 && Number.parseFloat(value) <= 90)){
            this.verticalAngleValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.verticalAngleValid = true;
          }
          break;
        case "minangle":
          if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 360)){
            this.minAlgleValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.minAlgleValid = true;
          }
          break;
        case "maxangle":
          if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 360)){
            this.maxAngleValid = false;
            //this.navaidController.selectedNavaid.doc = null;
          }else {
            this.maxAngleValid = true;
          }
          break;
      }
    }
  }
  cancelAngle():void{
    this.navaidService.activeAngles = !this.navaidService.activeAngles;
    this.angle = new ScreeningAngle();
  }

  addAngle():void {
    this.navaidService.selectedNavaid.addMinimumScreeningAngle(this.angle);
    this.angle = new ScreeningAngle();
    this.navaidService.activeAngles = !this.navaidService.activeAngles;
  }

}
